























import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import HeaderActionSearch from '@/components/layout/header/action/HeaderActionSearch.vue'
import HeaderActionNotification from '@/components/layout/header/action/HeaderActionNotification.vue'
import HeaderActionInbox from '@/components/layout/header/action/HeaderActionInbox.vue'
import HeaderActionProfile from '@/components/layout/header/action/HeaderActionProfile.vue'
import { UserRole } from '@/types/UserRole.type'
import RouteName from '@/utils/RouteName'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

const User = namespace('user')

@Component({
    components: { BaseIcon, HeaderActionProfile, HeaderActionInbox, HeaderActionNotification, HeaderActionSearch },
})
export default class HeaderAction extends Vue {
    @Prop({ type: String, required: true }) mode!: 'autocomplete' | 'search-all'
    @User.Getter hasRole!: (role: UserRole) => boolean

    RouteName: typeof RouteName = RouteName
}
